import React from 'react';

const MiniHero = ({text,url}) => {
    return (

        <div className="hero-section mini-hero-section"
             style={{/*backgroundPositionY: "top"*/ backgroundImage: `url(${url})`}}>
            <div className="container">
                <div className="hero-content">
                    <h1 className="hero-title whitespace-pre-wrap lg:whitespace-no-wrap ">{text}</h1>
                </div>
            </div>
        </div>
    );
};


export default MiniHero;